import CommonIconButton from "@/modules/common/components/ui-kit/buttons/icon-button";
import { Box, useTheme } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PathConstants } from "@/routes/constants";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { LeadActions } from "@/modules/lead-page/new/components/header/lead-actions";

const SidebarHeader = ({
  children,
  showActions = true,
}: {
  children: React.ReactNode;
  showActions?: boolean;
}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const { isMobile } = useScreenSize();

  return (
    <Box
      sx={{
        width: "100%",
        padding: theme.nawy.spacing.md,
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${theme.nawy.colors.semantic.border.secondary}`,
        borderTopLeftRadius: theme.nawy.radius.md,
        borderLeft: "none",
        gap: theme.nawy.spacing.md,
        borderTop: { mobile: "none" },
      }}
    >
      {!isMobile && (
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <CommonIconButton
            variant="outlined-secondary"
            size="md"
            onClick={() => {
              navigate(PathConstants.HOME);
            }}
          >
            <ArrowLeft
              size={16}
              style={{
                color: theme.nawy.colors.semantic.text.primary,
              }}
            />
          </CommonIconButton>
          {showActions && <LeadActions />}
        </Box>
      )}

      {children}
    </Box>
  );
};

export default SidebarHeader;
